// src/config.js
const config = {
  // API Configuration
  API_URL: process.env.REACT_APP_API_URL || "http://localhost:8000/api/v1",

  // App Configuration
  APP_NAME: process.env.REACT_APP_NAME || "Emmanuel Total DentalCare",
  APP_VERSION: process.env.REACT_APP_VERSION || "1.0.0",

  // Feature Flags
  FEATURES: {
    VERIFICATION: process.env.REACT_APP_FEATURE_VERIFICATION !== "false",
    NOTIFICATIONS: process.env.REACT_APP_FEATURE_NOTIFICATIONS !== "false",
    ONLINE_BOOKING: process.env.REACT_APP_FEATURE_ONLINE_BOOKING !== "false",
  },

  // Security Settings - Remove hardcoded values
  SECURITY: {
    SESSION_TIMEOUT: process.env.REACT_APP_SESSION_TIMEOUT
      ? parseInt(process.env.REACT_APP_SESSION_TIMEOUT)
      : 60 * 60 * 1000, // Use calculation instead of 3600000
    MAX_LOGIN_ATTEMPTS: process.env.REACT_APP_MAX_LOGIN_ATTEMPTS
      ? parseInt(process.env.REACT_APP_MAX_LOGIN_ATTEMPTS)
      : 5,
  },

  // Notification Settings
  NOTIFICATIONS: {
    EMAIL_ENABLED: process.env.REACT_APP_EMAIL_NOTIFICATIONS !== "false",
    SMS_ENABLED: process.env.REACT_APP_SMS_NOTIFICATIONS !== "false",
    REMINDER_HOURS: process.env.REACT_APP_REMINDER_HOURS
      ? parseInt(process.env.REACT_APP_REMINDER_HOURS)
      : 24,
  },
};

// Production checks
export const isProduction = process.env.NODE_ENV === "production";
export const isDevelopment = process.env.NODE_ENV === "development";

// Log configuration in development
// if (isDevelopment) {
//   console.log("App Configuration:", config);
// }

export { config };
